import { Dayjs } from "dayjs";

export class TransactionDownloadDto {
    year?: Dayjs | number | "";
    companyId?: number;
    reportType?: ReportType;
}

export type ReportType = "SUMMARY" | "RAW_DATA" | "EMISSION_FACTOR";

export type ReportTypeOption = {
    value: ReportType;
    label: string;
};
export const ReportTypeOptions: Array<ReportTypeOption> = [
    {
        label: "Summary Report",
        value: "SUMMARY",
    },
    {
        label: "Raw Data Report",
        value: "RAW_DATA",
    },
    {
        label: "Emission Factor Report",
        value: "EMISSION_FACTOR",
    },
];
